var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 6.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23H20.1364L19.8381 17.315C19.7453 15.6156 19.6989 14.1724 19.6989 12.9855C19.6989 12.3516 19.7055 11.8931 19.7188 11.6098L17.392 21.5029H14.6278L12.142 11.5896C12.1951 12.4123 12.2216 13.3362 12.2216 14.3613C12.2216 15.4538 12.1951 16.4586 12.142 17.3757L11.8438 23H9L10.0739 9L13.7926 9L16.0597 18.6503L18.1875 9L21.946 9L23 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLetter);
export default __webpack_public_path__ + "static/media/m-letter.079aa95675426070eb5ee234d88e0e95.svg";
export { ForwardRef as ReactComponent };